import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 426.667C0 191.025 191.025 0 426.667 0 662.308 0 853.333 191.025 853.333 426.667 853.333 662.308 662.308 853.333 426.667 853.333 191.025 853.333 0 662.308 0 426.667zM426.667 746.667C249.936 746.667 106.667 603.398 106.667 426.667 106.667 249.936 249.936 106.667 426.667 106.667 603.398 106.667 746.667 249.936 746.667 426.667 746.667 603.398 603.398 746.667 426.667 746.667zM0 1920V1066.67H853.333V1920H0zM106.667 1813.33V1173.33H746.667V1813.33H106.667zM1920 853.333 1440 0 960 853.333H1920zM1737.62 746.667 1440 217.571 1142.38 746.667H1737.62z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1386.67 1920V1546.67H1013.33V1440L1386.67 1440V1066.67H1493.33V1440H1866.67V1546.67H1493.33V1920H1386.67Z"
}));

var IconButtonAndIconMakerLine = /*#__PURE__*/function (_Component) {
  _inherits(IconButtonAndIconMakerLine, _Component);

  var _super = _createSuper(IconButtonAndIconMakerLine);

  function IconButtonAndIconMakerLine() {
    _classCallCheck(this, IconButtonAndIconMakerLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconButtonAndIconMakerLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconButtonAndIconMaker",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconButtonAndIconMakerLine.displayName = "IconButtonAndIconMakerLine";
  return IconButtonAndIconMakerLine;
}(Component);

IconButtonAndIconMakerLine.glyphName = 'button-and-icon-maker';
IconButtonAndIconMakerLine.variant = 'Line';
IconButtonAndIconMakerLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconButtonAndIconMakerLine;
export { IconButtonAndIconMakerLine };